// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-PEDUZ";
var _3 = "price__icon-2oZFR";
var _4 = "price__iconWrapper-20G7a";
export { _1 as "__esModule", _2 as "root", _3 as "price__icon", _4 as "price__iconWrapper" }
export default { "__esModule": _1, "root": _2, "price__icon": _3, "price__iconWrapper": _4 }
